"use client";

import { useEffect, useMemo } from "react";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import stylisRTLPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import useSettings from "../hooks/useSettings";

const RTL = ({ children }) => {
  const { settings } = useSettings();
  useEffect(() => {
    if (typeof document !== "undefined") {
      document.dir = settings.direction;
    }
  }, [settings.direction]);

  const cacheRtl = useMemo(() => {
    if (settings.direction !== "rtl") return null;
    return createCache({
      key: "rtl",
      prepend: true,
      stylisPlugins: [prefixer, stylisRTLPlugin],
    });
  }, [settings.direction]);

  if (cacheRtl) {
    return <CacheProvider value={cacheRtl}>{children}</CacheProvider>;
  }

  return <>{children}</>;
};

export default RTL;
